import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { services } from '../data/servicesData';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

const ServicePageSection = styled.section`
  padding: 120px 20px 60px;
  background-color: #f9fafb;
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

const ServiceTitle = styled.h1`
  font-size: 2.5rem;
  color: #111827;
  margin-bottom: 20px;
`;

const ServiceDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  color: #374151;
  margin-bottom: 30px;
`;

const BackLink = styled(Link)`
  display: inline-block;
  margin-top: 30px;
  color: #4f46e5;
  text-decoration: none;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
`;

const NotFoundContainer = styled(Container)`
  text-align: center;
`;

const ServicePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const service = services.find(s => s.slug === slug);

  if (!service) {
    return (
      <ServicePageSection>
        <NotFoundContainer>
          <Helmet>
            <title>Servicio No Encontrado</title>
          </Helmet>
          <ServiceTitle>Servicio No Encontrado</ServiceTitle>
          <ServiceDescription>
            El servicio que buscas no existe.
          </ServiceDescription>
          <BackLink to="/">Volver al Inicio</BackLink>
        </NotFoundContainer>
      </ServicePageSection>
    );
  }

  return (
    <ServicePageSection>
      <Container>
        <Helmet>
          <title>{`${service.title} - Dra. Suni Wiphala`}</title>
          <meta name="description" content={service.longDescription} />
        </Helmet>
        <ServiceTitle>{service.title}</ServiceTitle>
        <ServiceDescription>{service.longDescription}</ServiceDescription>
        <BackLink to="/#servicios">Ver todos los servicios</BackLink>
      </Container>
    </ServicePageSection>
  );
};

export default ServicePage;
